<template>
    <!-- Desktop (keeps UiModal) -->
    <UiModal
        v-if="!isMobile"
        :is-open="showAffiliateModal"
        title="Affiliate Disclosure"
        @close="closeModal"
    >
        <template #content>
            <div class="flex w-full justify-center">
                <div class="prose dark:prose-invert">
                    <img
                        src="/images/affiliate-disclosure.png"
                        class="mx-auto w-1/3 mb-1"
                        alt="Affiliate Disclosure"
                    />

                    <p class="mb-5">
                        10xTravel is part of an affiliate sales network and
                        receives compensation for sending traffic to partner
                        sites, such as CreditCards.com. This compensation may
                        impact how and where links appear on this site. This
                        site does not include all financial companies or all
                        available financial offers. Terms apply to American
                        Express benefits and offers. Enrollment may be required
                        for select American Express benefits and offers. Visit
                        americanexpress.com to learn more.
                    </p>

                    <p>
                        <strong>Editors Note:</strong>
                        Opinions expressed here are the author's alone, not those of
                        any bank, credit card issuer, hotel, airline, or other
                        entity. This content has not been reviewed, approved or
                        otherwise endorsed by any of the entities included
                        within the post.
                    </p>
                </div>
            </div>
        </template>
    </UiModal>

    <!-- Mobile using UiModalMobile -->
    <UiModalMobile
        v-if="isMobile"
        :is-open="showAffiliateModal"
        title="Affiliate disclosure"
        @close="closeModal"
    >
        <template #content>
            <div class="flex w-full flex-col items-center gap-6">
                <img
                    src="/images/affiliate-disclosure.png"
                    class="w-40 h-auto"
                    alt="Affiliate Disclosure"
                />
                <div class="text-slate-800 dark:text-slate-200 text-sm leading-6 space-y-4">
                    <p>
                        10xTravel is part of an affiliate sales network and
                        receives compensation for sending traffic to partner
                        sites, such as CreditCards.com. This compensation may
                        impact how and where links appear on this site. This
                        site does not include all financial companies or all
                        available financial offers. Terms apply to American
                        Express benefits and offers. Enrollment may be required
                        for select American Express benefits and offers. Visit
                        americanexpress.com to learn more.
                    </p>
                    <p>
                        <strong>Editors Note:</strong>
                        Opinions expressed here are the author's alone, not those of
                        any bank, credit card issuer, hotel, airline, or other
                        entity. This content has not been reviewed, approved or
                        otherwise endorsed by any of the entities included
                        within the post.
                    </p>
                </div>
            </div>
        </template>
        <template #footer>
            <button
                type="button"
                class="w-full h-11 rounded-lg bg-slate-800 dark:bg-slate-700 text-white text-sm font-medium"
                @click="closeModal"
            >
                Got it
            </button>
        </template>
    </UiModalMobile>
</template>

<script setup>
import { computed } from 'vue';
import { useAppStore } from '@/store/app';
import { useIsMobile } from '@/composables/useIsMobile';
import UiModal from '@/components/ui/modal/ui-modal.vue';
import UiModalMobile from '@/components/ui/modal/ui-modal-mobile.vue';

const appStore = useAppStore();
const { isMobile } = useIsMobile();

const showAffiliateModal = computed(() => appStore.showAffiliateModal);

const closeModal = () => {
    appStore.setShowAffiliateModal(false);
};
</script>
